import { get } from "../common/apiClient";

const PATH_EXAM_RESULT = "/exam-result";

// Lấy danh sách kết quả bài thi theo examId
const getExamResults = async (examId, page = 1, limit = 100) => {
  return await get(
    `${PATH_EXAM_RESULT}/ranking/${examId}?page=${page}&limit=${limit}`
  );
};

// Lấy tất cả kết quả bài thi (không phân trang) để export
const getAllExamResults = async (examId) => {
  return await get(
    `${PATH_EXAM_RESULT}/ranking/${examId}?page=1&limit=1000000`
  );
};

export { getExamResults, getAllExamResults };
